import React from 'react';
import { motion } from 'motion/react';

export const CartCardSkeleton: React.FC = () => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.5 }}
    className="relative rounded-2xl overflow-hidden shadow-lg"
    style={{
      background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.05))',
      backdropFilter: 'blur(20px)',
      WebkitBackdropFilter: 'blur(20px)',
      border: '1px solid rgba(255, 255, 255, 0.2)',
    }}
  >
    {/* Background Image Skeleton */}
    <div className="relative h-48 overflow-hidden bg-gray-800">
      <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent" />
      
      {/* Status Badge Skeleton */}
      <div className="absolute top-4 left-4">
        <div className="h-6 w-20 bg-gray-700 rounded-full animate-pulse" />
      </div>
    </div>

    {/* Content Skeleton - Glass Morphism Background */}
    <div 
      className="relative p-4 border-t border-white/20"
      style={{
        background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.08))',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
      }}
    >
      {/* Business Name and Location Skeleton */}
      <div className="mb-3 space-y-2">
        <div className="h-6 w-48 bg-gray-700/50 rounded animate-pulse" />
        <div className="flex items-center gap-2">
          <div className="h-3 w-3 bg-gray-700/50 rounded-full animate-pulse" />
          <div className="h-4 w-32 bg-gray-700/50 rounded animate-pulse" />
        </div>
      </div>

      {/* Expiration and Items Skeleton */}
      <div className="flex items-center justify-between text-sm">
        <div className="h-4 w-40 bg-gray-700/50 rounded animate-pulse" />
        <div className="h-4 w-24 bg-gray-700/50 rounded animate-pulse" />
      </div>

      {/* View Venue Button Skeleton */}
      <div className="absolute bottom-4 right-4">
        <div className="h-9 w-24 bg-gray-700/50 rounded-lg animate-pulse" />
      </div>
    </div>
  </motion.div>
);

export default CartCardSkeleton;

